import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { toast } from 'react-toastify'

import { toastErrorLog } from '../../helpers/toastErrorLog.js'
import { useAuth } from '../../hooks/useAuth'
import * as publicacionesService from '../servicios/publicacionesService'
import Borde from './Borde'
import IndicarCategorias from './IndicarCategorias'
import styles from './PublicacionMasiva.module.css'
import Upload from './Upload.jsx'

export const PublicacionMasiva = ({ errores, handleChange }) => {
  const fileInputRef = useRef()
  const [file, setFile] = useState(null)
  const { loginDataContext: { idUsuario } = {} } = useAuth()

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
    }
  }

  const handleSubirExcelClick = () => {
    fileInputRef.current.click()
  }

  const handleSubirExcel = async () => {
    try {
      const { data } = await publicacionesService.subirExcelCargaMasiva(file, {
        userId: idUsuario
      })
      toast.success(
        <div>
          Excel subido correctamente.
          <br />
          Job ID: {data.body.jobId}
        </div>
      )
    } catch (error) {
      toastErrorLog(error, 'Error al subir el Excel', 'excel-carga-masiva')
    }
  }

  return (
    <div className={styles.contenedor}>
      <Borde
        titulo="Seleccione las categorias de los productos que quiere cargar"
        activo={true}
        error={errores.idCategoria}
      >
        <IndicarCategorias onChange={handleChange} esMasiva={true} idUsuario={idUsuario} />
      </Borde>
      <Borde titulo="Agregá las fotos de tus publicaciones" activo={true}>
        <Upload accept={{ 'image/*': [] }} cargaMasiva={true} />
      </Borde>
      <div className={styles.subidaExcel}>
        <input
          type="file"
          accept=".xlsx,.xls"
          ref={fileInputRef}
          className={styles.hiddenInput}
          onChange={handleFileChange}
        />
        <button type="button" className="btn btn-secondary" onClick={handleSubirExcelClick}>
          Seleccionar archivo
        </button>
        {file && <span className="ml-3">{file.name}</span>}
        <button
          type="button"
          className="btn btn-primary"
          disabled={!file}
          onClick={handleSubirExcel}
        >
          Procesar excel
          <i className="fa fa-upload ml-2" />
        </button>
      </div>
    </div>
  )
}

PublicacionMasiva.propTypes = {
  errores: PropTypes.shape({
    idCategoria: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired,
  handleChange: PropTypes.func.isRequired
}
